import { gql } from '@apollo/client';
import { CreatorFields } from '../fragments';
import { AnalysisInfoFieldsFragment } from '../analysis/fragments';
import { DashboardInstanceFieldsFragment } from '../dashboards';
import { SlackDestinationFieldsFragment } from '../slack/fragments';

export const ScheduleHistoryFieldsFragment = gql`
  fragment ScheduleHistoryFields on Schedule {
    id
    name
    description
    type
    cron
    timezone
    paused
    emailList
    alertOnly
    lastRunStatus
    nextRunAt
    lastRunAt
    entityUrl
    entity {
      ... on AnalysisScheduleEntity {
        item {
          id
          display
          queryType
        }
        alertThresholds {
          list {
            ... on AlertThresholdAnomaly {
              kind
            }
            ... on AlertThresholdCustom {
              kind
              compareOp {
                key
                display
                requireComparison
              }
              compareValue
              valueIsPercent
              logicOp {
                key
                name
              }
            }
          }
        }
      }
      ... on DashboardScheduleEntity {
        item {
          ...DashboardInstanceFields
        }
      }
      ... on CohortScheduleEntity {
        item {
          ... on CompoundCohort {
            id
          }
          ... on ExpressionCohort {
            id
          }
          ... on FunnelCohort {
            id
          }
          ... on MeasureCohort {
            id
          }
          ... on PerformedCohort {
            id
          }
          ... on RetentionCohort {
            id
          }
        }
        brazeRemoveOutdated
      }
    }
    recipients {
      id
      email
      name
      picture
      lastLogin
    }
    creator {
      ...CreatorFields
    }
  }
  ${CreatorFields}
  ${DashboardInstanceFieldsFragment}
`;

export const ScheduleFieldsFragment = gql`
  fragment ScheduleFields on Schedule {
    id
    name
    description
    type
    cron
    timezone
    paused
    emailList
    alertOnly
    lastRunStatus
    nextRunAt
    lastRunAt
    entityUrl
    slackDestination {
      ...SlackDestinationFields
    }
    entity {
      ... on AnalysisScheduleEntity {
        item {
          ...AnalysisInfoFields
        }
        alertThresholds {
          list {
            ... on AlertThresholdAnomaly {
              kind
            }
            ... on AlertThresholdCustom {
              kind
              compareOp {
                key
                display
                requireComparison
              }
              compareValue
              valueIsPercent
              logicOp {
                key
                name
              }
            }
          }
        }
      }
      ... on DashboardScheduleEntity {
        item {
          ...DashboardInstanceFields
        }
        alertAnalyses {
          id
          queryType
          display
          createdAt
        }
      }
      ... on CohortScheduleEntity {
        item {
          ... on CompoundCohort {
            id
          }
          ... on ExpressionCohort {
            id
          }
          ... on FunnelCohort {
            id
          }
          ... on MeasureCohort {
            id
          }
          ... on PerformedCohort {
            id
          }
          ... on RetentionCohort {
            id
          }
        }
        brazeRemoveOutdated
      }
    }
    recipients {
      id
      email
      name
      picture
      lastLogin
    }
    creator {
      ...CreatorFields
    }
  }
  ${CreatorFields}
  ${AnalysisInfoFieldsFragment}
  ${DashboardInstanceFieldsFragment}
  ${SlackDestinationFieldsFragment}
`;
